import "src/css/widgets/widgets.css";

import { useMemo } from "react";
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { duotone, solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import { Row, Col } from 'react-bootstrap';
import React, { useState, useEffect } from 'react';
import MonitorWSService from 'src/services/monitorwsservice';
import { PieChart, Series, Size, Connector, Legend } from 'devextreme-react/pie-chart';
import WidgetSettings from "./widgetSettings"
import { removeWidget } from "src/redux/supervisorSlice";
import { selectionTypes } from "src/components/utils/consts";
import WidgetTools from "./widgetTools";
import AgentsStatusRender from "./agentsstatusrender";

function AgentsSummary(props) {

    const { t } = useTranslation();
    const [all, setAll] = useState(0);
    const [free, setFree] = useState(0);
    const [talking, setTalking] = useState(0);
    const [paused, setPaused] = useState(0);
    const [wrapup, setWrapup] = useState(0);
    const [agents, setAgents] = useState([]);
    const [showSettings, setShowSettings] = useState(false);
    const [groupId, setGroupId] = useState(-1);
    const [groupName, setGroupName] = useState(localStorage.getItem(`AgentsSummary_groupName_${props.identifier}_user${props.id}`) || t("all2"));

    useEffect(() => {
        // component mounts
        return () => {
            // component unmounts
            if (MonitorWSService?.stompClient?.connected) {
                MonitorWSService.stompClient.send("/app/unsubscribe/agentstatusdonut", {}, JSON.stringify({
                    token: props.token,
                    widgetId: props.identifier
                }));

                MonitorWSService.stompClient.unsubscribe(`agentsstatusdonut_${props.identifier}`);
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const MemoizedCenter = useMemo(() => (
        <AgentsStatusRender all={all} />
    ), [all]);

    useEffect(() => {
        if (props.connected) {

            let groupId = parseInt(localStorage.getItem(`AgentsSummary_groupId_${props.identifier}_user${props.id}`) || -1);
            setGroupId(groupId);

            MonitorWSService.stompClient.subscribe(`/user/${props.token}/topic/agentsstatusdonut_${props.identifier}/`, function (callssummary) {
                if (!document.hidden && localStorage.getItem("resizing") !== "true") {
                    var data = JSON.parse(callssummary.body);
                    let localAll = data.FreeAgents + data.TalkingAgents + data.PausedAgents + data.InWrapupTimeAgents;

                    if (isNaN(localAll))
                        localAll = 0;

                    setAll(localAll);
                    setFree(data.FreeAgents);
                    setTalking(data.TalkingAgents);
                    setPaused(data.PausedAgents);
                    setWrapup(data.InWrapupTimeAgents);

                    setAgents([{
                        "state": t("free"),
                        "amount": data.FreeAgents
                    },
                    {
                        "state": t("talking"),
                        "amount": data.TalkingAgents
                    },
                    {
                        "state": t("pause"),
                        "amount": data.PausedAgents
                    },
                    {
                        "state": t("wrapup"),
                        "amount": data.InWrapupTimeAgents
                    }
                    ])
                }
            }, { id: `agentsstatusdonut_${props.identifier}` });

            MonitorWSService.stompClient.send("/app/subscribe/agentstatusdonut", {}, JSON.stringify({
                token: props.token,
                groupId: groupId,
                widgetId: props.identifier
            }));
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.connected]);

    const toggleSettings = () => {
        setShowSettings(!showSettings);
    };

    const setGroup = (groupId, groupName) => {
        setShowSettings(!showSettings);
        setGroupId(groupId);
        setGroupName(groupName);
        localStorage.setItem(`AgentsSummary_groupId_${props.identifier}_user${props.id}`, groupId);
        localStorage.setItem(`AgentsSummary_groupName_${props.identifier}_user${props.id}`, groupName);
        MonitorWSService.stompClient.send("/app/subscribe/agentstatusdonut", {}, JSON.stringify({
            token: props.token,
            groupId: groupId,
            widgetId: props.identifier
        }));

    };

    const closeWidget = (e) => {
        e.preventDefault();
        props.close(props.identifier);
    }

    const customizePoint = (e) => {
        if (e.argument === t("free")) {
            return {
                color: "#50cd89"
            }
        }
        if (e.argument === t("talking")) {
            return {
                color: "#009ef7"
            }
        }
        if (e.argument === t("pause")) {
            return {
                color: "#f1416c"
            }
        }

        if (e.argument === t("wrapup")) {
            return {
                color: "#ffc700"
            }
        }
    }

    return (
        <div className={"card card-flush overflow-hidden h-lg-20 widget-container"} >
            <div className="card-header">
                <h3 className="card-title align-items-start flex-column text-primary drag-handle">
                    <span className="card-label fw-bold text-primary"><FontAwesomeIcon icon={duotone("users")} /> {t("agentsstatus")} - {groupName}</span>
                </h3>
                <div className="card-toolbar" style={{ zIndex: 9999 }}>
                    <WidgetTools key={`tools_${props.identifier}`} closeWidget={closeWidget} toggleSettings={toggleSettings}></WidgetTools>
                </div>
            </div>
            <div className="card-body" style={{ "padding": "0rem 2.25rem" }}>
                <Row>
                    <Col>
                        <div className="fs-3hx fw-bold text-gray-800 statsnumber">{talking}</div>
                        <div className="fs-5 fw-semibold mb-7">
                            <span className="text-primary"><FontAwesomeIcon icon={solid("circle")} /></span> {t("talking")}
                        </div>
                    </Col>
                    <Col> <div className="fs-3hx fw-bold text-gray-800 statsnumber">{free}</div>
                        <div className="fs-5 fw-semibold mb-7">
                            <span className="text-success"><FontAwesomeIcon icon={solid("circle")} /></span> {t("free")}
                        </div>
                    </Col>
                    <Col>
                        <div className="fs-3hx fw-bold text-gray-800 statsnumber">{paused}</div>
                        <div className="fs-5 fw-semibold mb-7">
                            <span className="text-danger"><FontAwesomeIcon icon={solid("circle")} /></span> {t("pause")}
                        </div>
                    </Col>
                    <Col>
                        <div className="fs-3hx fw-bold text-gray-800 statsnumber">{wrapup}</div>
                        <div className="fs-5 fw-semibold mb-7">
                            <span className="text-warning"><FontAwesomeIcon icon={solid("circle")} /></span> {t("wrapup")}
                        </div>
                    </Col>
                    <Col>
                        <PieChart
                            id="agentssummary"
                            dataSource={agents}
                            type="doughnut"
                            resolveLabelOverlapping="shift"
                            sizeGroup="piesGroup"
                            innerRadius={0.8}
                            customizePoint={customizePoint}
                            rtlEnabled={props.rtl}
                            centerRender={(pie) => MemoizedCenter}>
                            <Size
                                height={110}
                                width={130}
                            />
                            <Series
                                argumentField="state"
                                valueField="amount"
                            >
                                <Connector visible={true}></Connector>
                            </Series>
                            <Legend visible={false}></Legend>
                        </PieChart>
                    </Col>
                </Row>
            </div>
            <WidgetSettings key={`settings_${props.identifier}`} showSettings={showSettings} toggleSettings={toggleSettings} token={props.token} setGroup={setGroup} groupId={groupId} groupName={groupName} selectionType={selectionTypes.GROUP}></WidgetSettings>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        token: state.supervisor.token,
        connected: state.parameters.connected,
        id: state.supervisor.id,
        rtl: state.parameters.rtl
    };
};

export default connect(mapStateToProps, { removeWidget })(AgentsSummary);